import { TFunction } from "i18next";
import * as Yup from "yup";

import { ClientNoteMaxLength } from "./ClientNoteView.types";

export function createClientNoteSchema(t: TFunction) {
  return Yup.object().shape({
    note: Yup.string()
      .nullable()
      .max(ClientNoteMaxLength.note, ({ max }) => t("common.validation.maxLength", { max })),
  });
}
